function onCheckoutPaying(e) {
  if (__DEV__) {
    console.log('Web.Zephr:event: onCheckoutPaying', e);
  }

  // Do something stub onCheckoutPaying

  return;
}

export default onCheckoutPaying;
